import Image from "components/Elements/Image/Image.tsx";
import React from "react";

import "./Clouds.scss";

const Clouds = ({ type }) => {
  return (
    <div className="clouds-container">
      <Image name={`${type ? type + "-" : ""}clouds-left`} ext="png" />
      <Image name={`${type ? type + "-" : ""}clouds-right`} ext="png" />
    </div>
  );
};

export default Clouds;
